import Rebase from "re-base";
import firebase from "firebase";
import config from "./config";

console.log(config.firebase.authDomain);
const app = firebase.initializeApp(config.firebase);
const base = Rebase.createClass(app.database());

export { app, base };



// WEBPACK FOOTER //
// ./src/base.js